import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzRadio',
  props: {
    value: null,
    selectedOption: null,
    inputGroup: null,
    disabled: {
      type: Boolean
    },
    radioPosition: {
      default: 'left'
    }
  },
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var isChecked = computed(function () {
      return props.value === props.selectedOption;
    });
    var inputPosition = computed(function () {
      return props.radioPosition === 'right' ? 'row' : 'row-reverse';
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      isChecked: isChecked,
      inputPosition: inputPosition
    };
  }
});